<div class="auth-page">
  <!-- one wrapper card, two sections inside -->
  <div class="card">
    <!-- TOP: dark card (logo + title) -->
    <section class="hero">
      <header class="brand-header">
        <div class="logo" aria-label="Company logo">
          <img
            class="logo-svg"
            src="assets/logo_aposmart_lower_n.svg"
            alt="ApoSmart logo"
            width="200"
            height="200"
          />
        </div>

        <!-- moved inline styles to CSS via .portal-logo -->
        <span class="portal-logo">BRAND PORTAL</span>
      </header>
    </section>

    <!-- BOTTOM: white card (form) -->
    <section class="form-panel">
      <form class="login-form" (submit)="$event.preventDefault(); login()">
        <label>
          <span class="sr-only">E-postadress</span>
          <input
            type="email"
            [value]="email()"
            (input)="email.set($any($event.target).value)"
            placeholder="Email"
            autocomplete="email"
            required
            autofocus
          />
        </label>

        <label>
          <span class="sr-only">Lösenord</span>
          <input
            type="password"
            [value]="password()"
            (input)="password.set($any($event.target).value)"
            placeholder="Password"
            autocomplete="current-password"
            required
          />
        </label>

        <button type="submit" class="primary">Log in</button>

        @if (loginError()) { <div class="error">{{ loginError() }}</div> }
      </form>

      <nav class="helper-links">
        <a href="mailto:support@aposmart.se?subject=Forgot%20Password">Forgot password?</a>
      </nav>
    </section>
  </div>
</div>
